module.exports = __webpack_public_path__ + "img/621c417.png";